import router from '@/router'

router.beforeEach(async (to, from, next) => {
  // set page title
  let title = to.meta.title

  if (title === '') {
    if (to.matched.length > 2) {
      title = to.matched[to.matched.length - 2].meta.title
    }
  }
  document.title = title || ''

  next()
})

router.afterEach(() => {

})



// WEBPACK FOOTER //
// ./src/permission.js